import { http, tenantHttp, type HttpClient } from './core/http-client';
import type {
  EnforcementBusiness,
  EnforcementHistory,
  EnforcementState,
  NewEnforcement,
  OpenEnforcement,
} from './models';

// The business's own view: notices and whether it is suspended (tenant-scoped).
export class BusinessEnforcementService {
  constructor(private readonly http: HttpClient) {}

  state = () => this.http.get<EnforcementState>('/business/enforcement');
}

// Staff: Trust & Safety actions. Super admins, and admins switched on for it.
export class AdminEnforcementService {
  constructor(private readonly http: HttpClient) {}

  open = () => this.http.get<OpenEnforcement[]>('/admin/enforcement');

  options = () =>
    this.http.get<{ capabilities: { key: string; label: string }[] }>('/admin/enforcement/options');

  search = (q: string) =>
    this.http.get<EnforcementBusiness[]>('/admin/enforcement/businesses', { query: { q } });

  history = (businessId: string) =>
    this.http.get<EnforcementHistory>(`/admin/enforcement/businesses/${businessId}`);

  apply = (businessId: string, body: NewEnforcement) =>
    this.http.post<{ cancelledInvitations: number }>(
      `/admin/enforcement/businesses/${businessId}`,
      body,
    );

  lift = (id: string, reason: string) =>
    this.http.post<{ lifted: boolean }>(`/admin/enforcement/${id}/lift`, { reason });
}

export const businessEnforcementService = new BusinessEnforcementService(tenantHttp);
export const adminEnforcementService = new AdminEnforcementService(http);
